import {Component, EventEmitter, Input, Output, SimpleChanges} from "@angular/core";
import {Artifact} from "@webmate-web-core/shared/types/artifact";
import {ArtifactService} from "@webmate-web-core/shared/services/artifact.service";
import {ElementDescriptor} from "@webmate-web-core/shared/types/browsersession";
import {HighlightedElement} from "@webmate-web-core/shared/components/state/highlightedElement.stateinfo";
import {ImageService} from "@webmate-web-core/shared/services/image.service";
import {StateInfoItem} from "@webmate-web-core/shared/components/state/stateinfoitemrendererfactory";
import {ScreenshotViewerComponent, ScreenshotViewerToolConfig} from "@webmate-web-core/shared/tools/screenshotviewer/screenshotviewer.component";
import {ModalToolContainerService} from "@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.service";
import {ScreenshotId} from "@webmate-web-core/shared/types/ids";
import {faInfoCircle} from "@fortawesome/pro-light-svg-icons";
import {faCheckDouble, faExclamationTriangle, faInfoSquare} from "@fortawesome/pro-solid-svg-icons";
import {ImageMetadata} from "@webmate-web-core/shared/api/rest/image.restapi";
import {ObservationData} from "@webmate-web-core/shared/types/testmgmt";
import {Tag} from "@webmate-web-core/shared/types/tag";
import {filterAxeObservationsForSpec} from "@webmate-web-core/shared/services/specs";


@Component({
    selector: 'wm-a11yreport-artifact',
    templateUrl: './a11yreport-artifact.component.html',
    styleUrls: ['./a11yreport-artifact.component.less']
})
export class A11yReportArtifactComponent {

    @Input() artifact?: Artifact;

    @Input() showStats: boolean = false;

    @Input() specLabelFilter?: Tag[];

    // TODO: we probably also want an audit object filter

    @Output() addObservation = new EventEmitter<ObservationData>();

    reportData: any;
    violations: any[];
    filteredViolations: any[];
    stats: any;

    needAddToFindingsButton = false;

    activeTarget: any;
    activeTargetFailureSummary: string;
    activeViolation: any;

    activeElement?: ElementDescriptor;
    activeElementStateInfos?: StateInfoItem[];
    activeElementScreenshotMeta?: ImageMetadata;

    constructor(private artifactService: ArtifactService, private toolService: ModalToolContainerService,
                private imageService: ImageService) {}


    handleArtifact() {
        if (!this.artifact) {
            return;
        }

        this.reportData = this.artifact.data.reportData;
        this.violations = this.reportData.axeResults.violations;
        if (!this.specLabelFilter) {
            this.filteredViolations = this.violations;
        } else {
            this.filteredViolations = filterAxeObservationsForSpec(this.reportData.axeResults, this.specLabelFilter).violations;
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        this.handleArtifact();
        this.needAddToFindingsButton = this.addObservation.observed;
    }

    resetHighlightToActiveElement() {
        if (this.activeTarget?.target) {
        }
    }

    removeHighlight() {
    }

    // highlightObservation(violation, node, target: any) {
    // }

    emitAddObservation() {
        const observationInfo = this.collectObservationInfo();
        const finding: ObservationData = {
            type: 'WCAGReportObservation',
            summary: {
                ...observationInfo
            },
            elements: this.activeElement ? [this.activeElement] : [],
            reportArtifact: this.artifact!.id,
        }

        this.addObservation.emit(finding);
    }

    collectObservationInfo(): any {
        return {
            violationInfo: {
                summary: this.activeViolation?.help,
                explanation: this.activeViolation?.description,
                severity: this.activeViolation?.impact,
                labels: this.activeViolation?.tags,
            },
            targetInfo: {
                target: this.activeTarget?.target,
                node: this.activeTarget?.node,
                html: this.activeTarget?.html,
                failureSummary: this.createFailureSummary(this.activeTarget?.any?.map((node: any) => node.message) || [],
                    this.activeTarget?.all?.map((node: any) => node.message) || []),
            }
        };
    }

    highlightObservation(violation: any, node: any, target: any) {
    }

    showObservation(violation: any, node: any, target: any) {
        this.activeTarget = node;
        this.activeViolation = violation;

        this.activeElement = this.reportData.elements.find((element: any) => element.mainSelector?.selector === target);

        if (!!this.activeElement?.fullBoundingBox) {
            if (this.activeElement.elementScreenshot) {
                // these are relative to the entire page.
                const {xRel, yRel, widthRel, heightRel} = this.activeElement.fullBoundingBox;

                this.imageService.getImageMetadata(this.activeElement.elementScreenshot).subscribe(meta => {
                    this.activeElementScreenshotMeta = meta || undefined;

                    // as the screenshot is also relative to the page, we need to calculate the relative position of the element in the screenshot.
                    const {xRel: scrXRel, yRel: scrYRel, widthRel: scrWidthRel, heightRel: scrHeightRel} = meta?.position || {xRel: 0, yRel: 0, widthRel: 1, heightRel: 1};

                    // calculate the relative position of the element in the screenshot
                    const xRelInScr = xRel - scrXRel;
                    const yRelInScr = (yRel - scrYRel) * (1 / scrHeightRel);
                    const heightRelInScr = heightRel * (1 / scrHeightRel);
                    const widthRelInScr = widthRel * (1 / scrWidthRel);

                    this.activeElementStateInfos = [new HighlightedElement({x: xRelInScr, y: yRelInScr, width: widthRelInScr, height: heightRelInScr}, false, 'red', true, true)];
                });
            }
        }

        this.activeTargetFailureSummary = this.createFailureSummary(this.activeTarget?.any?.map((node: any) => node.message) || [],
            this.activeTarget?.all?.map((node: any) => node.message) || []);
        this.activeViolation = violation;
    }

    createFailureSummary(anyMessage: string[], allMessage: string[]) {
        let failureSummary = '';
        if (anyMessage.length > 0) {
            failureSummary += 'Fix any of the following:<br><ul class="repair-list">';
            anyMessage.forEach((message) => {
                failureSummary += '<li>' + message + '</li>';
            });
            failureSummary += '</ul>';
        }
        if (allMessage.length > 0) {
            failureSummary += 'Fix all of the following:<br><ul class="repair-list">';
            allMessage.forEach((message) => {
                failureSummary += '<li>' + message + '</li>';
            });
            failureSummary += '</ul>';
        }

        return failureSummary.replace(/\n/g, '<br>');
    }

    openScreenshotTool(imageId: ScreenshotId, infoItems: StateInfoItem[]) {
        this.toolService.openTool(ScreenshotViewerComponent, new ScreenshotViewerToolConfig(imageId, undefined, infoItems));
    }

    protected readonly faInfoCircle = faInfoCircle;
    protected readonly faInfoSquare = faInfoSquare;
    protected readonly faCheckDouble = faCheckDouble;
    protected readonly faExclamationTriangle = faExclamationTriangle;
}
